import { Injectable, TemplateRef, EmbeddedViewRef} from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
@Injectable({
    providedIn: 'root'
})
export class SnackbarService {

    constructor(
        private _snackBar: MatSnackBar
    ) {

    }

    public openSnackBar(message: string, horizontalPosition: HorizontalPositionEnum = HorizontalPositionEnum.CENTER, verticalPosition: VerticalPositionEnum = VerticalPositionEnum.BOTTOM, durationMs: number = 4000, button?: string) {
        this._snackBar.open(message ? message : "Une erreur est survenue", button, {
            duration: durationMs,
            horizontalPosition: horizontalPosition,
            verticalPosition: verticalPosition,
            panelClass: ['snack-bar']
        });
    }
    public openSnackBarSuccess(message: string, horizontalPosition: HorizontalPositionEnum = HorizontalPositionEnum.CENTER, verticalPosition: VerticalPositionEnum = VerticalPositionEnum.BOTTOM, durationMs: number = 4000, button?: string) {
      this._snackBar.open(message ? message : "Une erreur est survenue", button, {
          duration: durationMs,
          horizontalPosition: horizontalPosition,
          verticalPosition: verticalPosition,
          panelClass: ['snack-bar-success']
      });
    }
    public openSnackBarError(message: string, horizontalPosition: HorizontalPositionEnum = HorizontalPositionEnum.CENTER, verticalPosition: VerticalPositionEnum = VerticalPositionEnum.BOTTOM, durationMs: number = 4000, button?: string) {
      this._snackBar.open(message ? message : "Une erreur est survenue", button, {
          duration: durationMs,
          horizontalPosition: horizontalPosition,
          verticalPosition: verticalPosition,
          panelClass: ['snack-bar-error']
      });
    }
    public openSnackBarWarning(message: string, horizontalPosition: HorizontalPositionEnum = HorizontalPositionEnum.CENTER, verticalPosition: VerticalPositionEnum = VerticalPositionEnum.BOTTOM, durationMs: number = 4000, button?: string) {
      this._snackBar.open(message ? message : "Une erreur est survenue", button, {
          duration: durationMs,
          horizontalPosition: horizontalPosition,
          verticalPosition: verticalPosition,
          panelClass: ['snack-bar-warning']
      });
    }
    public openSnackFromTemplate(template: TemplateRef<any>, horizontalPosition: HorizontalPositionEnum = HorizontalPositionEnum.CENTER, verticalPosition: VerticalPositionEnum = VerticalPositionEnum.BOTTOM): MatSnackBarRef<EmbeddedViewRef<any>> {
      //pas de duration a gerer manuellement gestion validation temporiser fusion ou autre
      return this._snackBar.openFromTemplate(template, {
        horizontalPosition,
        verticalPosition,
        panelClass: ['snack-bar']
      });
    }
}

export enum HorizontalPositionEnum {
    START = 'start',
    CENTER = 'center',
    END = 'end',
    LEFT = 'left',
    RIGHT = 'right'
}

export enum VerticalPositionEnum {
    TOP = 'top',
    BOTTOM = 'bottom'
}
